module.exports = __webpack_public_path__ + "static/media/arrow-down.944fd0af.svg";